import { render } from "./DashboardAccordionItem.vue?vue&type=template&id=ef10b1a8&scoped=true"
import script from "./DashboardAccordionItem.vue?vue&type=script&lang=ts"
export * from "./DashboardAccordionItem.vue?vue&type=script&lang=ts"

import "./DashboardAccordionItem.vue?vue&type=style&index=0&id=ef10b1a8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ef10b1a8"

export default script